/*
==========================================================
Lunelle Wellness

Utilities

Shared helper methods used throughout the frontend.

==========================================================
*/

window.Lunelle=window.Lunelle||{};

Lunelle.Utils={

debounce(fn,delay=300){

let timer;

return(...args)=>{

clearTimeout(timer);

timer=setTimeout(()=>{

fn.apply(this,args);

},delay);

};

},

async fetchHTML(url){

const response=await fetch(url,{
headers:{
"X-Requested-With":"XMLHttpRequest"
}
});

if(!response.ok){

throw new Error(`Failed to fetch: ${url}`);

}

return response.text();

},

async fetchJSON(url,options={}){

const response=await fetch(url,{
headers:{
Accept:"application/json",
...options.headers
},
...options
});

if(!response.ok){

throw new Error(`Failed to fetch: ${url}`);

}

return response.json();

},

parseHTML(html){

return new DOMParser().parseFromString(
html,
"text/html"
);

},

serializeForm(form){

return new URLSearchParams(
new FormData(form)
);

},

fadeIn(element){

element.style.opacity=0;

element.style.display="";

requestAnimationFrame(()=>{

element.style.transition="opacity .25s ease";

element.style.opacity=1;

});

},

fadeOut(element){

element.style.opacity=1;

requestAnimationFrame(()=>{

element.style.transition="opacity .25s ease";

element.style.opacity=0;

});

},

scrollToTop(offset=40){

window.scrollTo({

top:offset,

behavior:"smooth"

});

},

focus(element){

if(element){

requestAnimationFrame(()=>{

element.focus();

});

}

}

};